import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import reducer from "./reducer";
import api from "./middleware/api";
import clearStorage from "./middleware/clearStorage";

export default function ConfigStore() {
  return configureStore({
    reducer,
    middleware: [
      ...getDefaultMiddleware({serializableCheck:false}),
      // logger({ destination: "console" }),
      api,
      clearStorage,
    ],
  });
}
